// extracted by mini-css-extract-plugin
export default {"searchTag":"manualpo__SearchTag-module__searchTag___BsuHC","removable":"manualpo__SearchTag-module__removable___R0Voa","closeBtn":"manualpo__SearchTag-module__closeBtn___zGjSd"};